import { fontClasses, FontProps, FONT_COLOR } from '../font-props';
import './font-heading5.scss';
import '../font.scss';

const FontHeading5: React.FC<FontProps> = (props): JSX.Element => {
    props = {
        ...props,
        color: typeof props.color === "undefined" ? FONT_COLOR.PRIMARY2 : props.color
    };

    return (
        <h5 className={`font font-heading5 ${fontClasses(props)}`}>{props.children}</h5>
    )
};

export default FontHeading5;
